import { Municipality } from './municipality.model';
import { User } from './user.model';

export enum CommunityStatus {
  Pending = 'pending',
  Created = 'created',
}

export interface Community {
  id: number;
  creationDate?: string;
  updatedDate?: string;
  name: string;
  userCount: number;
  groupUrl: string;
  status: CommunityStatus;
  municipality: Municipality | null;
  ambassador: User | null;
  members: User[];
}

export interface UserCommunity {
  id: number;
  isTemporary: boolean;
  community: Community;
}

export const nameRules = [
  (value: string) => {
    if (value) return true;

    return 'Name is required.';
  },
];
